import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export default function InstallApp() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => {
      setVisible(false);
      setDeferred(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);

    // iOS Safari has no beforeinstallprompt — offer manual instructions
    if (isIos()) setVisible(true);

    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      try {
        await deferred.userChoice;
      } catch {}
      setDeferred(null);
      setVisible(false);
    } else if (isIos()) {
      setIosHelp(true);
    }
  };

  if (!visible) return null;

  return (
    <>
      <button
        data-testid="install-app-button"
        onClick={onClick}
        className="fixed z-[60] bottom-5 right-5 flex items-center gap-2 px-4 h-11 rounded-full bg-gold text-obsidian font-semibold shadow-lg shadow-black/40 hover:bg-gold-hover transition-colors animate-fade-up"
      >
        <Download size={18} />
        <span className="text-sm">Uygulamayı Yükle</span>
      </button>

      {iosHelp && (
        <div
          className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/60 p-4"
          onClick={() => setIosHelp(false)}
          data-testid="ios-install-help"
        >
          <div
            className="w-full max-w-sm bg-surface border border-border rounded-xl p-5 text-foreground"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-display text-xl text-gold">Ana Ekrana Ekle</h3>
              <button onClick={() => setIosHelp(false)} data-testid="ios-help-close" className="text-muted-foreground hover:text-foreground">
                <X size={18} />
              </button>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              ORSE TOPTAN uygulamasını iPhone'a kurmak için:
            </p>
            <ol className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <span className="shrink-0 w-6 h-6 rounded-full bg-gold/15 text-gold flex items-center justify-center text-xs font-semibold">1</span>
                <span>Safari'de alttaki <Share size={14} className="inline -mt-0.5 text-gold" /> <b>Paylaş</b> düğmesine dokunun.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="shrink-0 w-6 h-6 rounded-full bg-gold/15 text-gold flex items-center justify-center text-xs font-semibold">2</span>
                <span><b>Ana Ekrana Ekle</b> seçeneğini seçin.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="shrink-0 w-6 h-6 rounded-full bg-gold/15 text-gold flex items-center justify-center text-xs font-semibold">3</span>
                <span>Sağ üstten <b>Ekle</b>'ye dokunun. ORSE TOPTAN artık ana ekranınızda!</span>
              </li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
